import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=7361125c&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7361125c')) {
      api.createRecord('7361125c', component.options)
    } else {
      api.reload('7361125c', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=7361125c&", function () {
      api.rerender('7361125c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2h84MOY71qHoH/JS/offershelp.vue"
export default component.exports